import $ from 'jquery';
import { parseQueryParams } from './shared/utils';
require('./page');

// @phone: moving homepage feature preview images to text block 
(function () {
  // / media query to check
  var phoneMQ = '(max-width: 800px) and (orientation: portrait)';
  // var phoneMQ = '(max-width: 1100px)';
  var isPhoneView = window.matchMedia(phoneMQ).matches;
  // matched or not
  if (isPhoneView) {
    var pas = $('#pricing-plans .pricing-actions-wrap')
    pas.each(function (i, pa) {
      // console.log('pa', pa)
      if (pa) {
        var ptwrap = pa.parentNode.parentNode
        if (ptwrap) {
          ptwrap.insertBefore(pa, ptwrap.querySelector('.pricing-table-head'))
        }
      }
    })
  }
}());

// @phone: pricing tabs func 
(function () {
  // / media query to check
  var phoneMQ = '(max-width: 800px) and (orientation: portrait)';
  // var phoneMQ = '(max-width: 1100px)';
  // matched or not
  var isPhoneView = window.matchMedia(phoneMQ).matches;
  if (isPhoneView) {
    $("#pricing-cdn .subtext").text('viewers');

    var onPricingTabActive = function (el) {
      $('.plan-id-wrap').removeClass('tab-active')
      el = $(el)
      el.addClass('tab-active')
      // var tabIndex = el.data().productColId + 1
      var tabIndex = el.data().productColId

      $('#table-tab-css').remove()
      var css = document.createElement('style')
      css.id = 'table-tab-css'
      css.innerHTML = `.feat-row td:nth-of-type(${tabIndex}) {display: table-cell !important;}`
      document.body.appendChild(css)

      console.log('el', el)
    }

    var planHeads = $('.plan-id-wrap')
    planHeads.on('click', function () { onPricingTabActive(this) });
    onPricingTabActive(planHeads[0])

    var onPlanTypeChange = function () {
      var activeEntity = $(this).data('entity');
      var showCompanyPlans = activeEntity === 'company';
      if (this.tagName === 'INPUT') {
        showCompanyPlans = this.checked === true;
      }

      if (showCompanyPlans) {
        onPricingTabActive(planHeads[4])
      } else {
        onPricingTabActive(planHeads[0])
      }
    }

    $('.pricing-entity-switch .period-control').on('click', onPlanTypeChange)
    $('.pricing-switch-checkbox').on('change', onPlanTypeChange);

    // preselect 6th cdn pricing tab
    $('#pricing-cdn .plan-id-wrap[data-product-col-id=1]').click()
  }
}());

// live delivert type switch
// (function () {
//   $('.live-cat-tabs .live-cat-tab').on('click', function () {
//     var el = $(this)
//     el.addClass('selected')
//     el.siblings().removeClass('selected')
//   })
// })();

// init plans list type tabs
// (function () {
//   var tab_selector = '.live-cat-tabs[data-plans-list-selection] .live-cat-tab'
//   $(tab_selector).on('click', function () {

//     var targetPlansList = $(this).data().targetPlansList;
//     $(tab_selector).each(function (i, node) {
//       var el_ = $(this);
//       if (el_.data().targetPlansList === targetPlansList) {
//         el_.addClass('selected')
//       } else {
//         el_.removeClass('selected')
//       }
//     })

//     $('[data-plans-list-type]').each((function (i, node) {
//       node = $(node);
//       if (node.data().plansListType === targetPlansList) {
//         node.show()
//       } else {
//         node.hide()
//       }
//     }));
//   });
// })();

// force enable annual billing on pageload
(function () {
  // $('.pricing-switch-wrap [data-period="y"]').trigger('click')
  // $('.pricing-switch-wrap [data-period="y"]').get(0).click()
})();

// force enable annual billing on pageload
(function () {
  var params = parseQueryParams();
  // if (params.plans_category === 'live-stream-hosting') {
  //   $('.live-cat-tabs[data-plans-list-selection] .live-cat-tab').get(1).click()
  // }


  // if (window.location.href.includes('/live-stream-hosting')) {
  //   $('.live-cat-tabs[data-plans-list-selection] .live-cat-tab').get(1).click()
  // }

  // import axios from 'axios';
  // import $ from 'jquery';
  // import { parseQueryParams } from './shared/utils';

  // in-page pricing period toggle logic
  (function () {
    document.addEventListener("DOMContentLoaded", function () {
      const toggleButtons = document.querySelectorAll(".toggle-element");
      const priceElements = document.querySelectorAll(".plan-cost-amount");
      const priceUnitElements = document.querySelectorAll(".plan-cost-unit");
      const billingLabels = document.querySelectorAll(".plan-billing-period");

      toggleButtons.forEach(button => {

        button.addEventListener("click", function () {
          const selectedType = button.getAttribute("data-type"); // 'monthly' or 'yearly'

          // Update prices
          priceElements.forEach(el => {
            const monthlyPrice = el.getAttribute("data-monthly-price");
            const annualPrice = el.getAttribute("data-annual-price");

            el.textContent = selectedType === "monthly"
              ? `$${monthlyPrice}`
              : `$${annualPrice}`;
          });

          // priceUnitElements.forEach(el => {
          //   el.innerHTML = selectedType === "monthly"
          //     ? 'per month'
          //     : 'per month'
          // })

          // Update billing labels
          billingLabels.forEach(label => {
            label.textContent = selectedType === "monthly"
              ? "Billed Monthly"
              : "Billed Yearly";
          });

          // Update active button state (optional)
          // toggleButtons.forEach(btn => btn.classList.remove("active"));
          toggleButtons.forEach(btn => {

            const btnPeriodUnit = btn.getAttribute("data-type"); // 'monthly' or 'yearly'
            if (btnPeriodUnit === selectedType) {
              btn.classList.add("active")
              btn.classList.add("toggle-element-checked");
            } else {
              btn.classList.remove("active")
              btn.classList.remove("toggle-element-checked")
            }

          });

          // button.classList.add("toggle-element-checked");

          // let otherButton = (button.nextElementSibling || button.previousElementSibling)
          // if (otherButton) {
          //   otherButton.classList.remove("toggle-element-checked");
          // }
        });
      });
    });


  }());

  // in-page customer reviews scroller
  document.addEventListener("DOMContentLoaded", function () {
    const sliders = document.querySelectorAll(".customer-review-card-list");

    sliders.forEach(slider => {
      const cards = slider.children;
      const cardWidth = cards[0].offsetWidth + parseInt(getComputedStyle(cards[0]).marginRight);
      let scrollPosition = 0;
      let isPaused = false;

      // Clone cards to enable seamless looping
      const cloneCount = Math.ceil(slider.offsetWidth / cardWidth) + 1;
      for (let i = 0; i < cloneCount; i++) {
        slider.appendChild(cards[i % cards.length].cloneNode(true));
      }

      function autoScroll() {
        if (!isPaused) {
          scrollPosition += 0.5;
          if (scrollPosition >= slider.scrollWidth / 2) {
            scrollPosition = 0;
            slider.scrollLeft = 0;
            // console.log('slider.scrollLeft=0')
          } else {
            slider.scrollLeft = scrollPosition;
            // console.log('slider.scrollLeft=', scrollPosition)
          }
        }

        // setTimeout(() => {
        //   autoScroll()
        // }, 0);
        requestAnimationFrame(autoScroll);
      }

      autoScroll();

      // Pause/resume on hover
      slider.addEventListener("mouseover", () => isPaused = true);
      slider.addEventListener("mouseout", () => isPaused = false);
    })

  });

})();